import React from 'react';
import { Box } from '@mui/material';
import { Permission, Resource } from '@pepperhq/auth-client';

import { useAppSelector } from 'store/hooks';
import { isDefined } from 'lib/typeguards';
import { ILocationScopedSettingsComponentProps } from './LocationScopedSettings';
import { ShopifySettingsCard } from './Integrations/Shopify/ShopifySettingsCard';
import { KlaviyoSettingsDisplay } from './Integrations/Klaviyo/KlaviyoSettingsDisplay';

export const IntegrationsSettings: React.FC<ILocationScopedSettingsComponentProps> = ({
    settings,
    globalSettings,
    locationId,
    onSettingsSaved
}) => {
    const { claims } = useAppSelector(state => state.auth);
    const canViewShopify = claims.hasPermission(Resource.ShopifyPrivateSetting, Permission.write);
    const canViewKlaviyo = claims.hasPermission(Resource.KlaviyoPrivateSetting, Permission.write);

    if (isDefined(locationId)) {
        return (
            <Box minWidth="500px">
                {canViewShopify && (
                    <ShopifySettingsCard {...{ settings, globalSettings, locationId, onSettingsSaved }} />
                )}
            </Box>
        );
    }
    return (
        <Box minWidth="500px">
            {canViewKlaviyo && (
                <KlaviyoSettingsDisplay {...{ settings, globalSettings, locationId, onSettingsSaved }} />
            )}
        </Box>
    );
};
